import {
    Avatar, Badge, Box, Button, ButtonGroup, Card, CardHeader, Chip, CircularProgress,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton,
    Input, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText,
    Paper, Step, StepContent, StepLabel, Stepper, Typography, TextField, Slider, CardContent,
    FormControl, InputLabel, Select, MenuItem

} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { SwipeableListItem } from '@sandstreamdev/react-swipeable-list';
import '@sandstreamdev/react-swipeable-list/dist/styles.css';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Chart } from 'react-charts';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import axios from 'src/utils/axios';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import DoneIcon from '@material-ui/icons/Done';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import { getUser, moneyFormat } from 'src/utils/Common';
import SendIcon from '@material-ui/icons/Send';
import { setTask } from '../store/actions/taskActions';
import { paymentThunks } from 'src/store/slices/paymentSlice';
import {
    getHistoricalMaterialRequest, setCurrentDefect, setDefectFilterKey, setLabourFilterKey,
    setLabourSelection, setMaterialFilterKey, setMaterialSelection, setVatType
} from '../store/actions';
import ComplexSwipeContent from './ComplexSwipeContent';
import SelectDefect from './SelectDefect';
import SelectLabour from './SelectLabour';
import SelectMaterial from './SelectMaterial';
import moment from 'moment';
import ErrorDialog from './ErrorDialog';
import ErrorMessage from './ErrorMessage';
import CropFreeIcon from '@material-ui/icons/CropFree';
import { RoundKm } from 'src/utils/Common';


const useStyles = makeStyles((theme) => ({
    root: {},
    ListDiv: {
        backgroundColor: theme.palette.common.siyah,
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    error: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    value: {
        fontWeight: theme.typography.fontWeightMedium
    },
    type: {
        fontWeight: theme.typography.fontWeightMedium
    },
    search: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIcon: {
        marginRight: theme.spacing(2),
        color: theme.palette.icon
    },
    searchInput: {
        flexGrow: 1
    },
    pageStyle: {
        display: 'flex',
        padding: '2px 4px',
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    searchButton: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(2)
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    content: {
        marginLeft: theme.spacing(0),
    },
    nested: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    nestedRight: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(7),
    },
    smallIcon: {
        height: 15,
        width: 15,
    },
    toplam: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        align: 'right',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1)
        }
    },
    action: {
        paddingTop: 12,
    },
}));

const defaultProps = {
    bgcolor: 'background.paper',
    // borderColor: "grey.500",
    borderColor: '#1D3343',
    border: 1,
    marginLeft: 0.5,
    marginRight: 0.5,
    marginBottom: 0.5,
};

const defaultPropsChild = {
    bgcolor: 'background.paper',
    borderColor: '#cfcfcf',
    border: 1,
    marginLeft: 0.5,
    marginRight: 0.5,
    marginBottom: 0.5,
};

const SmallAvatar = withStyles((theme) => ({
    root: {
        width: 20,
        height: 20,
        // border: `2px solid ${theme.palette.background.paper}`,
    },
}))(Avatar);

function DefectPage(props) {
    const classes = useStyles();
    const { t } = useTranslation('work_order');
    const [Km, setKm] = React.useState(0);
    const [openDefect, setOpenDefect] = React.useState(false);
    const [openMaterial, setOpenMaterial] = React.useState(false);
    const [openLabour, setOpenLabour] = React.useState(false);
    const [materialSum, setMaterialSum] = React.useState(0);
    const [transportSum, setTransportSum] = React.useState(0);
    const [ExtraSum, setExtraSum] = React.useState(0);
    const [labourSum, setLabourSum] = React.useState(0);
    const [materialVatSum, setMaterialVatSum] = React.useState(0);
    const [transportVatSum, setTransportVatSum] = React.useState(0);
    const [ExtraVatSum, setExtraVatSum] = React.useState(0);
    const [labourVatSum, setLabourVatSum] = React.useState(0);
    const [stokOpen, setStokOpen] = React.useState(false);
    const [NonIotOpen, setNonIotOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [TotalExtraNewPriceParam, setTotalExtraNewPriceParam] = React.useState(0);
    const [extraFeeNote, setExtraFeeNote] = React.useState('');
    const [TotalExtraNewPrice, setTotalExtraNewPrice] = React.useState(0.00);
    const [stokData, setStokData] = React.useState([]);
    const [GosterimAdet, setGosterimAdet] = React.useState(250);
    const [open, setOpen] = React.useState(false);
    const [grafikGetir, setgrafikGetir] = React.useState(true);
    const [Uyari, setUyari] = React.useState('');
    const [ExtraPaymentDetailDsc, setExtraPaymentDetailDsc] = React.useState('');
    const SessionUser = getUser();
    const [ExtraOpen, setExtraOpen] = React.useState(false);
    const [TotalExtraPrice, setTotalExtraPrice] = React.useState(0.0);
    const [ExtraPaymentTypeData, setExtraPaymentTypeData] = React.useState([]);
    const [materialCode, setMaterialCode] = React.useState([]);
    const [priceVisible, setPriceVisible] = React.useState(true);
    const [stokDataOwnEngineer, setStokDataOwnEngineer] = React.useState([]);
    const [backButtonVisible, setBackButtonVisible] = React.useState(false);
    const [stockMsg, setStockMsg] = React.useState('');
    const [serviceShopTypeId, setServiceShopTypeId] = React.useState();
    const [IsAllOwnEngineer, setIsAllOwnEngineer] = React.useState(false);

    const isOnline = useSelector((state) => state.status?.isOnline);

    const [DeviceBarcode, setDeviceBarcode] = React.useState('');
    const [response, setResponse] = React.useState("");
    const [OpenBarkodkart, setOpenBarkodkart] = React.useState(false);
    const [OpenBarkodCihaz, setOpenBarkodCihaz] = React.useState(false);
    const [messageErrorDialog, setMessageErrorDialog] = React.useState('');
    const [openErrorDialog, setOpenErrorDialog] = React.useState(false);
    const [VatOpen, setVatOpen] = React.useState(false);
    const [vatRates, setVatRates] = React.useState([]);
    const [selectedVat, setSelectedVat] = React.useState('');
    const [KartBarcode, setKartBarcode] = React.useState('');
    const vatType = useSelector((state) => state.defectReducer?.vatType);
    const posTenantVatRateData = useSelector(s => s.payment?.posTenantVatRateData);
    const isPosTenantVat = posTenantVatRateData?.IsSuccess === true;
    const posTenantVatRateValue = posTenantVatRateData?.ResponseObject?.VatRate ?? 0.21;
    const dispatch = useDispatch();
    const [automaticDistanceCalculationIsActive, setAutomaticDistanceCalculationIsActive] = React.useState(false);


    const handleClose = () => {
        setOpen(false);
    };

    const DataDefect = props.readonly ? props.tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(props.ReceiptNo)) : loadBaslandiJob();

    useEffect(() => {
        dispatch(paymentThunks.GetPosTenantVatRate());
    }, []);

    useEffect(() => {
        let mounted = true;
        let WarrantyTypeId = props.tasks.tasks[0]?.WarrantyTypeId;
        let LocationId = 0;
        const fetchTodos = () => {
            axios
                .get(
                    '/GetSiriusTransport/' +
                    SessionUser.ServiceShopId +
                    '/' +
                    WarrantyTypeId +
                    '/' +
                    LocationId +
                    '/' +
                    props.ReceiptNo
                )
                .then(response => {
                    if (mounted) {
                        const Response = response.data === '' ? [] : response.data;
                        setExtraPaymentTypeData(Response);
                        if (props.tasks.tasks[0]?.WorkOrderTransport.length > 0) {
                            setKm(
                                props.tasks.tasks[0]?.WorkOrderTransport[0]?.Count === ''
                                    ? ''
                                    : Number(props.tasks.tasks[0]?.WorkOrderTransport[0]?.Count)
                            );

                            var ExtraPrice = ExtraPaymentTypeData.filter(
                                x =>
                                    parseInt(x.Min) <=
                                    parseInt(
                                        props.tasks.tasks[0]?.WorkOrderTransport[0]?.Count
                                    ) &&
                                    parseInt(x.Max) >=
                                    parseInt(props.tasks.tasks[0]?.WorkOrderTransport[0]?.Count)
                            );

                            setTotalExtraPrice(
                                props.tasks.tasks[0]?.WorkOrderTransport[0]?.MaterialPrice
                            );

                            setExtraPaymentDetailDsc(ExtraPrice[0]?.ExtraDesc);
                        }
                        setTotalExtraNewPrice(props.tasks.tasks[0]?.WorkOrderExtra[0]?.MaterialPrice || 0);
                        setExtraFeeNote(props.tasks.tasks[0]?.WorkOrderExtra[0]?.ExtraFeeNote || '')
                        setLoading(false);
                    }
                })
                .catch(error => {
                    setLoading(false);
                });
        };
        fetchTodos();
        return () => {
            mounted = false;
        };
    }, []);



    useEffect(() => {


        const fetchTodos = () => {
            axios
                .get(
                    '/GetVatValues'
                )
                .then(response => {
                    if (response.data.length > 0) {
                        setVatRates(response.data);
                    } else {
                        setVatRates([]);
                    }
                });
        };
        fetchTodos();
    }, []);


    useEffect(() => {
        let currMaterialSum = 0;
        let currLabourSum = 0;
        let currTransportSum = 0;
        let currExtraSum = 0;
        let currMaterialVatSum = 0;
        let currLabourVatSum = 0;
        let currTransportVatSum = 0;
        let currExtraVatSum = 0;
        if (props.defects && props.defects.selected) {
            props.defects.selected.forEach((row, index) => {
                if (props.materials && props.materials.materialsTable) {
                    if (props.materials[row]) {
                        props.materials[row].forEach((mrow, index) => {
                            if(isPosTenantVat){
                                currMaterialSum += props.materials[mrow] * Math.round(props.materials.materialsTable[mrow].PriceWithWat * 100) / 100;
                                currMaterialVatSum += props.materials[mrow] * Math.round(props.materials.materialsTable[mrow].Price * 100) / 100;
                                setPriceVisible(props.materials.materialsTable[mrow].PriceVisible);
                            }
                            else{
                                currMaterialSum += props.materials[mrow] * props.materials.materialsTable[mrow].PriceWithWat;
                                currMaterialVatSum += props.materials[mrow] * props.materials.materialsTable[mrow].Price;
                                setPriceVisible(props.materials.materialsTable[mrow].PriceVisible);
                            }
                            
                        });
                    }
                }
                if (props.labours && props.labours.laboursTable) {
                    if (props.labours[row]) {
                        props.labours[row].forEach((mrow, index) => {
                            if(isPosTenantVat){
                                currLabourSum += Math.round(props.labours.laboursTable[mrow].PriceWithWat * 100) / 100;
                                currLabourVatSum += Math.round(props.labours.laboursTable[mrow].Price * 100) / 100;
                                setPriceVisible(props.labours.laboursTable[mrow].PriceVisible);
                            }
                            else{
                                currLabourSum += props.labours.laboursTable[mrow].PriceWithWat;
                                currLabourVatSum += props.labours.laboursTable[mrow].Price;
                                setPriceVisible(props.labours.laboursTable[mrow].PriceVisible);
                            }

                            
                        });
                    }
                }
            });
        }


        DataDefect[0].WorkOrderTransport.forEach((mrow, index) => {
            if(isPosTenantVat){
                currTransportSum += Math.round(mrow.MaterialPriceWithWat * 100) / 100;
                currTransportVatSum += Math.round(mrow.MaterialPrice * 100) / 100;
            }
            else{
                currTransportSum += mrow.MaterialPriceWithWat;
                currTransportVatSum += mrow.MaterialPrice;
            }
            
        });
        DataDefect[0].WorkOrderExtra.forEach((mrow, index) => {
            if(isPosTenantVat){
                currExtraSum += Math.round(mrow.MaterialPriceWithWat * 100) / 100;
                currExtraVatSum += Math.round(mrow.MaterialPrice * 100) / 100;
            }
            else{
                currExtraSum += mrow.MaterialPriceWithWat;
                currExtraVatSum += mrow.MaterialPrice;
            }
        });

        if (props.tasks.tasks[0]?.WarrantyTypeId === 471) {
            currMaterialVatSum = 0;
            currMaterialSum = 0;
        }

        setMaterialSum(currMaterialSum);
        setLabourSum(currLabourSum);


        setMaterialVatSum(currMaterialVatSum);
        setLabourVatSum(currLabourVatSum);

        setExtraVatSum(currExtraVatSum);
        setExtraSum(currExtraSum);


        setTransportVatSum(currTransportVatSum);
        setTransportSum(currTransportSum);

        setExtraSum(parseFloat(TotalExtraNewPrice) * (1 + ((ExtraPaymentTypeData && ExtraPaymentTypeData.length > 0) ? ExtraPaymentTypeData[0]?.VatRate : 0)));
        setExtraVatSum(parseFloat(TotalExtraNewPrice));

        // eslint-disable-next-line
    }, [props.defect, props.labours, props.materials, ExtraPaymentTypeData, TotalExtraNewPrice, DataDefect]);
    const IscilikSil = (Iscilik, index, Hizmet) => {
        const Uyari = `${Iscilik.LabourCode} ${Iscilik.LabourDesc} ${t('Sil')}`;
        confirmAlert({
            message: Uyari,
            buttons: [
                {
                    label: t('Evet'),
                    onClick: () => IscilikSilEvet(Iscilik, index, Hizmet)
                },
                {
                    label: t('Hayir'),
                    onClick: () => { }
                }
            ]
        });
    };
    const IscilikSilEvet = (Iscilik, index, Hizmet) => {
        const selected = props.labours[Hizmet] || [];
        const selectedIndex = selected.indexOf(Iscilik.LabourCode);
        let newSelected = [];
        if (selectedIndex === -1) {
            return;
        }
        newSelected = [...selected.slice(0, selectedIndex),
        ...selected.slice(selectedIndex + 1)
        ];
        props.setLabourSelection(Hizmet, newSelected);
    };
    const MalzemeSil = (Malzeme, index, Hizmet) => {
        const Uyari = `${Malzeme.MaterialCode} ${Malzeme.MaterialDesc} ${t('Sil')}`;
        confirmAlert({
            message: Uyari,
            buttons: [
                {
                    label: t('Evet'),
                    onClick: () => MalzemeSilEvet(Malzeme, index, Hizmet)
                },
                {
                    label: t('Hayir'),
                    onClick: () => { }
                }
            ]
        });
    };
    const MalzemeSilEvet = (Malzeme, index, Hizmet) => {
        const selected = props.materials[Hizmet] || [];
        const selectedIndex = selected.indexOf(Malzeme.MaterialCode);
        let newSelected = [];
        if (selectedIndex === -1) {
            return;
        }
        newSelected = [...selected.slice(0, selectedIndex),
        ...selected.slice(selectedIndex + 1)
        ];

        props.setMaterialSelection(Hizmet, newSelected);
    };
    const tarihselAgacSorgula = () => {
        const job = loadBaslandiJob()[0];
        props.getHistoricalMaterialRequest(job.KUL_MODEL_KODU || '', job.GARANTI_TIPI || 1, 1, job.UYIL, job.UDONEM);
    };

    const setExtraPrice = () => {
        let ExtraPrice = ExtraPaymentTypeData.filter(
            x => parseInt(x.Min) <= parseInt(Km) && parseInt(x.Max) >= parseInt(Km)
        );

        let data = {
            Km,
            MaterialId: ExtraPrice[0]?.MaterialId || 0,
            PriceId: ExtraPrice[0]?.PriceId || 0,
            Price: parseFloat(TotalExtraPrice) || 0,
            VatRate: ExtraPaymentTypeData[0]?.VatRate || 0,
            VatId: ExtraPaymentTypeData[0]?.VatId || 0,
            ExtraPrice: parseFloat(TotalExtraNewPrice),
            WorkOrderId: props.ReceiptNo,
            ExtraFeeNote: extraFeeNote,
            EmployeeId: SessionUser.TechnicianId,
        };

        const config = {
            headers: { 'Content-Type': 'application/json' },
        };

        axios
            .post('/SetTransport', data, config)
            .then(response => {
                const res = response.data.length === 0 ? [] : response.data;

                let TaskTransportData = [
                    {
                        MaterialId: ExtraPrice[0]?.MaterialId || 0,
                        DefectId: 0,
                        MaterialCode: 'TRNS',
                        Count: Km,
                        MaterialDesc: 'Route Payment',
                        MaterialPrice: parseFloat(TotalExtraPrice) || 0,
                        MaterialPriceWithWat: (parseFloat(TotalExtraPrice) || 0) * (1 + (ExtraPrice[0]?.VatRate || 0)),
                        MaterialPriceId: ExtraPrice[0]?.PriceId || 0,
                        MaterialPriceListId: 0,
                        VatRate: ExtraPrice[0]?.VatRate || 0,
                        VatId: ExtraPrice[0]?.VatId || 0,
                    },
                ];

                let TaskExtraData = [
                    {
                        MaterialId: 0,
                        DefectId: 0,
                        MaterialCode: 'EXT',
                        Count: 1,
                        MaterialDesc: 'Extra Payment',
                        MaterialPrice: parseFloat(TotalExtraNewPrice),
                        MaterialPriceWithWat: parseFloat(TotalExtraNewPrice) * (1 + (ExtraPaymentTypeData[0]?.VatRate || 0)),
                        MaterialPriceId: 0,
                        MaterialPriceListId: 0,
                        VatRate: ExtraPaymentTypeData[0]?.VatRate || 0,
                        VatId: ExtraPaymentTypeData[0]?.VatId || 0,
                    },
                ];

                let job = loadBaslandiJob()[0];
                job = {
                    ...job,
                    WorkOrderTransport: TaskTransportData,
                    WorkOrderExtra: TaskExtraData,
                };

                setTransportSum(
                    (parseFloat(TotalExtraPrice) || 0) * (1 + (ExtraPrice[0]?.VatRate || 0))
                );
                setTransportVatSum(parseFloat(TotalExtraPrice) || 0);

                setExtraSum(
                    parseFloat(TotalExtraNewPrice) * (1 + (ExtraPaymentTypeData[0]?.VatRate || 0))
                );
                setExtraVatSum(parseFloat(TotalExtraNewPrice));

                saveBaslandiJob(job);
                setExtraOpen(false);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error posting transport data:', error);
                setLoading(false);
            });
    };

    const giveUyari = () => {
        setUyari(t('Malzeme_Seciniz_error'));
        setOpen(true);
    };

    const SetExtraNote = (e) => {
        setExtraFeeNote(e.target.value);
    }

    const handleBackButtonClick = () => {
        setBackButtonVisible(false);
        GetMaterialAvailabilityOwnEngineer(false);
    };

    const deleteExtraPrice = () => {
        let ExtraPrice = ExtraPaymentTypeData.filter(
            x => parseInt(x.Min) <= parseInt(Km) && parseInt(x.Max) >= parseInt(Km)
        );
        let data = {
            Km,
            MaterialId: 0,
            PriceId: 0,
            Price: 0,
            VatRate: 0,
            VatId: 0,
            ExtraPrice: 0,
            WorkOrderId: props.ReceiptNo,
            ExtraFeeNote: extraFeeNote,
            EmployeeId: SessionUser.TechnicianId
        };

        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        axios
            .post('/SetTransport', data, config)
            .then(response => {
                const res = response.data.length === 0 ? [] : response.data;
                let TaskTransportData = [
                    {
                        MaterialId: 0,
                        DefectId: 0,
                        MaterialCode: 'TRNS',
                        Count: Km,
                        MaterialDesc: 'Route Payment',
                        MaterialPrice: 0,
                        MaterialPriceWithWat: 0,
                        MaterialPriceId: 0,
                        MaterialPriceListId: 0,
                        VatRate: 0,
                        VatId: 0
                    }
                ];
                let TaskExtraData = [
                    {
                        MaterialId: 0,
                        DefectId: 0,
                        MaterialCode: 'EXT',
                        Count: 1,
                        MaterialDesc: 'Extra Payment',
                        MaterialPrice: 0,
                        MaterialPriceWithWat: 0,
                        MaterialPriceId: 0,
                        MaterialPriceListId: 0,
                        VatRate: 0,
                        VatId: 0
                    }
                ];
                var job = loadBaslandiJob()[0];
                job = {
                    ...job,
                    WorkOrderTransport: TaskTransportData,
                    WorkOrderExtra: TaskExtraData,
                };

                setTransportSum(0);
                setTransportVatSum(0);

                setExtraSum(0);
                setExtraVatSum(0);

                saveBaslandiJob(job);
                setExtraOpen(false);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    };

    const handleChangeKm = event => {
        if (event.target.value < 1) {
            setTotalExtraPrice(0);
            setKm(0);
            setExtraPaymentDetailDsc("");
            return;
        }

        const isAllFactorOne = ExtraPaymentTypeData?.length > 1 && ExtraPaymentTypeData.every(x => x.Factor === 1);


        let ExtraPrice = ExtraPaymentTypeData.filter(
            x =>
                parseInt(x.Min) <= parseInt(event.target.value) &&
                parseInt(x.Max) >= parseInt(event.target.value)
        );
        if (ExtraPrice[0]?.Factor === 0) {
            setTotalExtraPrice(ExtraPrice[0]?.Price);
        }
        else if ((SessionUser.TenantId == 58 || SessionUser.TenantId == 62 || SessionUser.TenantId == 12 || SessionUser.TenantId == 37 || SessionUser.TenantId == 118 || SessionUser.TenantId == 75) && ExtraPrice[0]?.Factor === 1) {
            let basePrice = ExtraPaymentTypeData.filter(
                x => x.Factor == 0
            )[0].Price;
            setTotalExtraPrice((ExtraPrice[0]?.Price * (parseInt(event.target.value) - ExtraPrice[0]?.Min)) + basePrice);
        }
        else if ((SessionUser.TenantId === 53 || SessionUser.TenantId == 39 || SessionUser.TenantId == 64) && ExtraPrice[0]?.Factor === 1) {
            setTotalExtraPrice(ExtraPrice[0]?.Price * (parseInt(event.target.value)));

        }
        else if (SessionUser.TenantId === 49 && isAllFactorOne) {
            let progressiveTotal = 0;
            let totalKm = parseInt(event.target.value);

            let applicableTiers = ExtraPaymentTypeData
                .filter(x => x.Factor === 1)
                .sort((a, b) => parseInt(a.Min) - parseInt(b.Min));

            applicableTiers.forEach(tier => {
                if (totalKm >= parseInt(tier.Min)) {

                    let kmsInThisTier = Math.min(totalKm, parseInt(tier.Max)) - (parseInt(tier.Min) - 1);

                    if (kmsInThisTier > 0) {
                        progressiveTotal += (kmsInThisTier * tier.Price);
                    }
                }
            });

            setTotalExtraPrice(progressiveTotal);
        }
        else {
            setTotalExtraPrice(ExtraPrice[0]?.Price * (parseInt(event.target.value) - ExtraPrice[0]?.Min));
        }

        setExtraPaymentDetailDsc(ExtraPrice[0]?.ExtraDesc);
        setKm(event.target.value === '' ? '' : Number(event.target.value));
    };

    const handleNonIotOpen = () => {
        setNonIotOpen(true);
        setgrafikGetir(true);
    };
    const setNonIotChartOpen = () => {
        setgrafikGetir(false);
    };


    const getActionHeader = (e) => {


        const ReturnValue = (
            <Grid container spacing={1}>
                <Grid item xs={6} sm={6} lg={6} align="right">
                    <IconButton
                        edge="end"
                        size="small"
                        disabled={props.readonly}
                        className={classes.action}
                        onClick={() => handleExtraOpen(props)}
                    >
                        <Badge
                            overlap="circle"
                            size="small"
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            badgeContent={<SmallAvatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>
                                +
                            </SmallAvatar>}
                        >
                            <Avatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>{t('T')}</Avatar>
                        </Badge>
                    </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6} align="left">
                    <IconButton
                        edge="end"
                        size="small"
                        disabled={props.readonly}
                        className={classes.action}
                        onClick={() => handleStokOpen()}
                    >
                        <Badge
                            overlap="circle"
                            size="small"
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            badgeContent={(
                                <SmallAvatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>
                                    <DoneIcon />
                                </SmallAvatar>
                            )}
                        >
                            <Avatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}><DeveloperBoardIcon /></Avatar>
                        </Badge>
                    </IconButton>
                </Grid>
            </Grid>
        );
        return ReturnValue;
    };

    const handleStokOpen = () => {
        setBackButtonVisible(false);

        let malzemeler = [];
        props.defects.selected.forEach(s => {
            if (props.materials[s] !== undefined) {
                malzemeler = [...malzemeler, ...props.materials[s]];
            }
        });
        if (malzemeler.length === 0) {
            setUyari(t('Malzeme_Seciniz_input'));
            setOpen(true);
            return;
        }
        setStokOpen(true);
        setLoading(true);

        GetMaterialAvailabilityOwnEngineer(false);

        const Request = {
            MaterialCode: malzemeler,
            ServiceShopCode: SessionUser.ServiceShopCode
        };

        const RequestHeaders = {
            headers: { 'Content-Type': 'application/json' }
        };
        axios
            .post('/GetMaterialAvailabilitySirius', Request, RequestHeaders)
            .then(response => {
                const res = response.data.length === 0 ? [] : response.data;
                const stokQuantity = res.map(item => ({
                    ...item,
                    Quantity: parseInt(item.Quantity, 10)
                }));
                setStokData(stokQuantity);
                setMaterialCode(malzemeler);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    };

    const handleExtraOpen = async (props) => {
        let isActive = false;
        setExtraOpen(true);
        setLoading(true);
        try {
            const response = await axios.get(`/GetDefinedValue/13`); // 13: Automatic Distance Calculation
            isActive = response.data?.Value === 1 ? true : false;
            setAutomaticDistanceCalculationIsActive(isActive);
        } catch (error) {
            isActive = false;
            setAutomaticDistanceCalculationIsActive(false);
        }


        if (isActive) {
            try {
                const response = await axios.get(`/CalculateDistanceByWorkOrderId/${props.ReceiptNo}`);
                const res = response.data;
                if (res?.KmInt) {
                    let roundedKm = RoundKm(res.KmInt);
                    handleSliderChange(null, roundedKm);
                }
            } catch (error) {
                console.error("Distance calculation error:", error);
            }
        }
        setLoading(false);
    };

    const AddExtraPriceNew = (e) => {
        setTotalExtraNewPrice(e.target.value);
        setTotalExtraNewPriceParam(e.target.value)
    }


    const handleSliderChange = (event, newValue) => {
        if (newValue < 1) {
            newValue = 0;
        }
        let ExtraPrice = ExtraPaymentTypeData.filter(
            x =>
                parseInt(x.Min) <= parseInt(newValue) &&
                parseInt(x.Max) >= parseInt(newValue)
        );

        if (ExtraPrice.length > 0) {
            const isAllFactorOne = ExtraPaymentTypeData?.length > 1 && ExtraPaymentTypeData.every(x => x.Factor === 1);

            if (ExtraPrice[0]?.Factor === 0) {
                setTotalExtraPrice(ExtraPrice[0]?.Price);
            }
            else if ((SessionUser.TenantId == 58 || SessionUser.TenantId == 62 || SessionUser.TenantId == 12 || SessionUser.TenantId == 118 || SessionUser.TenantId == 75) && ExtraPrice[0]?.Factor === 1) {
                let basePrice = ExtraPaymentTypeData.filter(
                    x => x.Factor == 0
                )[0].Price;

                setTotalExtraPrice((ExtraPrice[0]?.Price * (parseInt(newValue) - ExtraPrice[0]?.Min)) + basePrice);
            }

            else if ((SessionUser.TenantId === 53 || SessionUser.TenantId == 39 || SessionUser.TenantId == 64) && ExtraPrice[0]?.Factor === 1) {
                setTotalExtraPrice(ExtraPrice[0]?.Price * (parseInt(newValue)));

            }

            else if (SessionUser.TenantId === 49 && isAllFactorOne) {
                let progressiveTotal = 0;
                let totalKm = parseInt(newValue);

                let applicableTiers = ExtraPaymentTypeData
                    .filter(x => x.Factor === 1)
                    .sort((a, b) => parseInt(a.Min) - parseInt(b.Min));

                applicableTiers.forEach(tier => {
                    if (totalKm >= parseInt(tier.Min)) {

                        let kmsInThisTier = Math.min(totalKm, parseInt(tier.Max)) - (parseInt(tier.Min) - 1);

                        if (kmsInThisTier > 0) {
                            progressiveTotal += (kmsInThisTier * tier.Price);
                        }
                    }
                });

                setTotalExtraPrice(progressiveTotal);
            }

            else {
                setTotalExtraPrice(ExtraPrice[0]?.Price * (parseInt(newValue) - ExtraPrice[0]?.Min));
            }

            setExtraPaymentDetailDsc(ExtraPrice[0]?.ExtraDesc);
        } else {
            setTotalExtraPrice(0);
            setExtraPaymentDetailDsc("");
        }
        setKm(newValue);
    };


    const GetMaterialAvailabilityOwnEngineer = (value) => {
        setIsAllOwnEngineer(value);

        let malzemeler = [];
        props.defects.selected.forEach(s => {
            if (props.materials[s] !== undefined) {
                malzemeler = [...malzemeler, ...props.materials[s]];
            }
        });
        if (malzemeler.length === 0) {
            setUyari(t('Malzeme_Seciniz_input'));
            setOpen(true);
            return;
        }

        setLoading(true);

        const Request = {
            MaterialCode: malzemeler,
            ServiceShopId: SessionUser.ServiceShopId,
            IsAllOwnEngineer: value
        };

        const RequestHeaders = {
            headers: { 'Content-Type': 'application/json' }
        };
        axios
            .post('/GetMaterialAvailabilityOwnEngineer', Request, RequestHeaders)
            .then(response => {
                const res = response.data.length === 0 ? [] : response.data;
                if (res.length > 0) {
                    const stokQuantity = res.map(item => ({
                        ...item,
                        Quantity: parseInt(item.Quantity, 10)
                    }));
                    setStokDataOwnEngineer(stokQuantity);
                    setServiceShopTypeId(res[0].ServiceShopTypeId);
                }
                else {
                    setStokDataOwnEngineer([]);
                    setStockMsg(t('lblStockMsg'))
                }

                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const StockSearch = () => {
        let malzemeler = [];
        props.defects.selected.forEach(s => {
            if (props.materials[s] !== undefined) {
                malzemeler = [...malzemeler, ...props.materials[s]];
            }
        });
        if (malzemeler.length === 0) {
            setUyari(t('Malzeme_Seciniz_input'));
            setOpen(true);
            return;
        }

        GetMaterialAvailabilityOwnEngineer(true);
        setBackButtonVisible(true);
    }


    const getStokColor = (s) => {
        if (s.Quantity > 0) {
            return <Avatar size="small" style={{ color: 'white', backgroundColor: 'green' }}><ShoppingCartIcon /></Avatar>;
        }
        return <Avatar size="small" onClick={() => { setUyari(s.Date || ''); setOpen(true); }} style={{ color: '#424242', backgroundColor: 'red' }}><ShoppingCartIcon /></Avatar>;
    };

    const axes = React.useMemo(
        () => [
            { primary: true, type: 'ordinal', position: 'bottom' },
            { position: 'left', type: 'linear', stacked: true }
        ],
        []
    );
    const series = React.useMemo(
        () => ({
            type: 'bar'
        }),
        []
    );
    const data = React.useMemo(
        () => [
            {
                label: 'Series 1',
                dataType: 'ordinal',
                data: [['S?cakl?k', 18], ['Gaz', 40]]
            }
        ],
        []


    );




    function getSteps() {
        return [t('lblProductInfo'),
        t('lblDeviceInfo')];
    }
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const handleNext = () => {
        if (activeStep !== steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            return;
        }
        let user = getUser();
        let body = {
            UserName: user.UserId || '',
            BonaDeviceCode: DeviceBarcode || '',
            ModelCode: props.kulModelKodu || '',
            ProductBarcode: props.Barcode || '',
            WorkOrderId: props.ReceiptNo || 0
        }
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        setLoading(true);

        axios.post('/BonaDataCollection', body, config)
            .then(res => {
                setResponse(res.data.message);
                setLoading(false);
                setActiveStep(steps.length);
            }).catch(err => {
                setResponse(err.message);
                setLoading(false);
                setActiveStep(steps.length);
            });
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const handleKartBarkodOpen = () => {
        setOpenBarkodkart(true);
    };
    const handleCihazBarkodOpen = () => {
        setOpenBarkodCihaz(true);
    };


    const GetBonaPdfData = async () => {
        try {
            setLoading(true);
            const WorkOrderId = props.ReceiptNo;

            const response = await axios.get(`/download-pdf?WorkOrderId=${WorkOrderId}`, { responseType: 'blob' });

            const reader = new FileReader();
            reader.onload = () => {
                try {
                    const result = reader.result;
                    if (typeof result === 'string' && result.startsWith('{')) {
                        const errorData = JSON.parse(result);
                        setMessageErrorDialog(`${t('lblErrorPdf')}: ${errorData.title} - ${errorData.status}`);
                        setOpenErrorDialog(true);
                    } else {
                        const file = new Blob([response.data], { type: 'application/pdf' });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(file);
                        link.download = 'BonaData.pdf';
                        link.click();
                        URL.revokeObjectURL(link.href);
                    }
                } catch (error) {
                    const file = new Blob([response.data], { type: 'application/pdf' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(file);
                    link.download = 'BonaData.pdf';
                    link.click();
                    URL.revokeObjectURL(link.href);
                }
            };

            reader.readAsText(response.data);
        } catch (error) {
            const errorMessage = error.response?.data
                ? `${t('lblErrorPdf')}: ${error.response.data.title} - ${error.response.data.status}`
                : `${t('lblErrorPdf')}: ${error.message}`;
            setMessageErrorDialog(errorMessage);
            setOpenErrorDialog(true);
        } finally {
            setLoading(false);
        }
    };

    function SetWorkOrderVat(newVat) {

        const WorkOrderId = parseInt(props.ReceiptNo);

        let job = props.tasks.tasks.find(
            d => parseInt(d.ReceiptNo) === parseInt(WorkOrderId)
        );

        const fakeEvent = { target: { value: 0 } };

        setLoading(true);
        axios.post('/SetWorkOrderVat/' + WorkOrderId + '/' + newVat)
            .then((response) => {
                setUyari(true);
                // setUyariAciklama(t('vattype_changed_message'));
                props.resetLabours();
                props.resetMaterials();
                props.resetDefects();
                setLoading(false);
                props.getDefectRequest(job.ModelCode, 1, []);
                props.getMaterialRequest(
                    job.ModelCode,
                    job.WarrantyTypeId,
                    1,
                    0,
                    0,
                    job?.ReceiptNo || 0
                );
                props.getLabourRequest(job.ModelCode, job.WarrantyTypeId, 1, '', job?.ReceiptNo || 0);
                job = { ...job, HIZMETLER: [], ISCILIKLER: [], MALZEMELER: [] };
                props.setTask(job);
                deleteExtraPrice();
                handleChangeKm(fakeEvent);
                AddExtraPriceNew(fakeEvent);
                handleSliderChange(fakeEvent, 0);
                // fetchSiriusTransportData();
            })
    };

    const handleVatOpen = props => {
        setVatOpen(true);
    };

    const handleVatChange = (event) => {
        const newVat = event.target.value;
        setSelectedVat(newVat);
        dispatch(setVatType(newVat));
        SetWorkOrderVat(newVat);
        setVatOpen(false);
    };




    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <div>
                        <Typography className={classes.title} color="textSecondary">
                            {t('lblBarkod')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                            {props.Barcode}
                        </Typography>
                        <Typography className={classes.title} color="textSecondary">
                            {t('lblModelCode')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                            {props.kulModelKodu}
                        </Typography>
                        <Typography className={classes.title} color="textSecondary">
                            {t('Urun')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                            {props.Model}
                        </Typography>
                        <Typography className={classes.title} color="textSecondary">
                            {t('input_uyil')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                            {props.Uyil}
                        </Typography>
                        <Typography className={classes.title} color="textSecondary">
                            {t('input_udonem')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                            {props.Udonem}
                        </Typography>
                        <Typography className={classes.title} color="textSecondary">
                            {t('input_serino')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                            {props.SeriNo}
                        </Typography>
                    </div>

                )
        };









        let gridSize = SessionUser.TenantId === 12 ? 4 : 6;










    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title" color="primary">{t('Bilgilendirme')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {Uyari}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {t('Tamam')}
                    </Button>
                </DialogActions>
            </Dialog>
            {isOnline ? (
                <Card>
                    <CardHeader
                        avatar={(
                            <IconButton
                                edge="end"
                                size="small"
                                disabled={props.readonly}
                                onClick={() => (!props.readonly ? setOpenDefect(true) : giveUyari())}
                            >
                                <Badge
                                    overlap="circle"
                                    size="small"
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    badgeContent={<SmallAvatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>+</SmallAvatar>}
                                >
                                    <Avatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>{t('D')}</Avatar>
                                </Badge>
                            </IconButton>
                        )}
                        title={(
                            <Typography variant="h6">
                                {t('HizmetEkle')}
                                {' '}
                            </Typography>
                        )}
                        action={getActionHeader(data)}
                    />
                    <List component="div" dense>
                        {(props.defects.selected) && props.defects.selected.map((row, index) => {
                            if (!props.defects.defectsTable) return null;
                            const dd = props.defects.defectsTable[row];
                            const montaj = dd?.DefectTypeCode === 3;
                            return dd && (
                                <Box key={row} borderRadius={16} {...defaultProps}>
                                    <ListItem key={row}>
                                        <ListItemText primary={<Typography variant="h6">{`${dd.UserCode} - ${dd.DefectDesc}`}</Typography>} />
                                        {!props.readonly && (
                                            <div>
                                                <IconButton
                                                    edge="end"
                                                    size="small"
                                                    disabled={props.readonly}
                                                    onClick={() => {
                                                        props.setCurrentDefect(row);
                                                        setOpenLabour(true);
                                                    }}
                                                >

                                                    <Badge
                                                        overlap="circle"
                                                        size="small"
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'right',
                                                        }}
                                                        badgeContent={<SmallAvatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>+</SmallAvatar>}
                                                    >
                                                        <Avatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>{t('L')}</Avatar>
                                                    </Badge>
                                                </IconButton>
                                                <IconButton
                                                    edge="end"
                                                    size="small"
                                                    disabled={props.readonly}
                                                    onClick={() => {
                                                        props.setCurrentDefect(row);
                                                        setOpenMaterial(true);
                                                    }}
                                                >
                                                    <Badge
                                                        overlap="circle"
                                                        size="small"
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'right',
                                                        }}
                                                        badgeContent={<SmallAvatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>+</SmallAvatar>}
                                                    >
                                                        <Avatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>{t('M')}</Avatar>
                                                    </Badge>
                                                </IconButton>
                                            </div>
                                        )}
                                    </ListItem>
                                    <Box borderRadius={16} {...defaultPropsChild}>
                                        {(props.labours[row])
                                            && props.labours[row].map((mrow, index) => (
                                                <ListItem dense key={mrow}>
                                                    <SwipeableListItem
                                                        dense
                                                        swipeLeft={{
                                                            content: (
                                                                <ComplexSwipeContent
                                                                    icon={<DeleteSweepIcon />}
                                                                    label={t('SilButon')}
                                                                    position="right"
                                                                    css="hizmet"
                                                                />
                                                            ),
                                                            action: () => IscilikSil(props.labours.laboursTable[mrow], index, row)
                                                        }}
                                                        blockSwipe={props.readonly}
                                                    >
                                                        <ListItemText>
                                                            <Typography key={mrow} variant="body1" className={classes.nestedRight}>
                                                                <b>{`${mrow} `}</b>
                                                                {props.labours.laboursTable[mrow].LabourDesc}
                                                            </Typography>
                                                        </ListItemText>
                                                        <ListItemSecondaryAction className={classes.nested}>
                                                            {props.labours.laboursTable[mrow].PriceVisible ? <>
                                                                <Typography variant="h6">
                                                                    {((moneyFormat(props.labours.laboursTable[mrow].Price, SessionUser.TenantCode, SessionUser.CurrencyUnit)))}
                                                                    {` ${SessionUser.CurrencyUnit}`}
                                                                </Typography>
                                                            </> : ''}
                                                        </ListItemSecondaryAction>
                                                    </SwipeableListItem>
                                                </ListItem>
                                            ))}
                                    </Box>
                                    <Box borderRadius={16} {...defaultPropsChild}>
                                        {(props.materials[row])
                                            && props.materials[row].map((mrow, index) => (
                                                <ListItem dense key={mrow}>
                                                    <SwipeableListItem
                                                        dense
                                                        swipeLeft={{
                                                            content: (
                                                                <ComplexSwipeContent
                                                                    icon={<DeleteSweepIcon />}
                                                                    label={t('SilButon')}
                                                                    position="right"
                                                                    css="hizmet"
                                                                />
                                                            ),
                                                            action: () => MalzemeSil(props.materials.materialsTable[mrow], index, row)
                                                        }}
                                                        blockSwipe={props.readonly}
                                                    >
                                                        <ListItemText>
                                                            <Typography key={mrow} variant="body1" className={classes.nestedRight}>
                                                                <b>{mrow}</b>
                                                                {` ${props.materials.materialsTable[mrow]?.MaterialDesc} Ref:${props.materials.materialsTable[mrow]?.Ref}`}
                                                            </Typography>
                                                            <Divider />
                                                        </ListItemText>
                                                        <ListItemSecondaryAction className={classes.nested}>
                                                            {props.materials.materialsTable[mrow].PriceVisible ? <>
                                                                <Typography variant="h6">
                                                                    {moneyFormat(props.materials.materialsTable[mrow].Price, SessionUser.TenantCode, SessionUser.CurrencyUnit)}
                                                                    {` ${SessionUser.CurrencyUnit}`}
                                                                    <br />
                                                                </Typography>
                                                            </> : ''}
                                                            <Typography variant="body1">
                                                                {`${props.materials[mrow] || '1'} ${t('lblAdet')}`}
                                                            </Typography>
                                                        </ListItemSecondaryAction>
                                                    </SwipeableListItem>
                                                </ListItem>
                                            ))}
                                    </Box>
                                </Box>
                            );
                        })}
                    </List>
                    <Divider />
                    <Grid container spacing={0}>
                        {priceVisible ? <>
                            <Grid item xs={6} align="right">
                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    {t('iscilik_Toplami')}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} align="right">
                                <Typography variant="h6" gutterBottom>
                                    {moneyFormat(labourVatSum, SessionUser.TenantCode, SessionUser.CurrencyUnit)}
                                </Typography>
                            </Grid>
                            <Grid item xs={2} align="center">
                                <Typography variant="h6" gutterBottom>
                                    {SessionUser.CurrencyUnit}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} align="right">
                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    {t('malzeme_Toplami')}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} align="right">
                                <Typography variant="h6" gutterBottom>
                                    {moneyFormat(materialVatSum, SessionUser.TenantCode, SessionUser.CurrencyUnit)}
                                </Typography>
                            </Grid>
                            <Grid item xs={2} align="center">
                                <Typography variant="h6" gutterBottom>
                                    {SessionUser.CurrencyUnit}
                                </Typography>
                            </Grid>
                        </> : ''}
                        <Grid item xs={6} align="right">
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                {t('yol_Toplami')}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} align="right">
                            <Typography variant="h6" gutterBottom>
                                {moneyFormat(transportVatSum, SessionUser.TenantCode, SessionUser.CurrencyUnit)}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} align="center">
                            <Typography variant="h6" gutterBottom>
                                {SessionUser.CurrencyUnit}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} align="right">
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                {t('lblExtraPrice')}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} align="right">
                            <Typography variant="h6" gutterBottom>
                                {moneyFormat(ExtraVatSum, SessionUser.TenantCode, SessionUser.CurrencyUnit)}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} align="center">
                            <Typography variant="h6" gutterBottom>
                                {SessionUser.CurrencyUnit}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider variant="inset" />
                        </Grid>
                        <Grid item xs={6} align="right">
                            <Typography className={classes.title} style={{ color: 'red' }} color="textSecondary" gutterBottom>
                                {t('lblVatTotal')}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} align="right">
                            <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                                {priceVisible ?
                                    isPosTenantVat
                                        ? moneyFormat(
                                            Math.round(materialVatSum * 100) / 100
                                            + Math.round(labourVatSum * 100) / 100
                                            + Math.round(transportVatSum * 100) / 100
                                            + Math.round(ExtraVatSum * 100) / 100, SessionUser.TenantCode, SessionUser.CurrencyUnit
                                        )
                                        : moneyFormat(
                                            (materialVatSum + labourVatSum + transportVatSum + ExtraVatSum), SessionUser.TenantCode, SessionUser.CurrencyUnit
                                        )
                                    :
                                    moneyFormat(
                                        (transportVatSum + ExtraVatSum), SessionUser.TenantCode, SessionUser.CurrencyUnit
                                    )
                                }
                            </Typography>
                        </Grid>
                        <Grid item xs={2} align="center">
                            <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                                {SessionUser.CurrencyUnit}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} align="right">
                            <Typography className={classes.title} style={{ color: 'red' }} color="textSecondary" gutterBottom>
                                {t('lblVat')}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} align="right">
                            <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                                {priceVisible ?
                                    isPosTenantVat
                                        ? moneyFormat(
                                            (() => {
                                                const vatTotal = Math.round(materialSum * 100) / 100 + Math.round(labourSum * 100) / 100 + Math.round(transportSum * 100) / 100 + Math.round(ExtraSum * 100) / 100;
                                                const base = Math.round(vatTotal / (1 + posTenantVatRateValue) * 100) / 100;
                                                return Math.round((vatTotal - base) * 100) / 100;
                                            })(), SessionUser.TenantCode, SessionUser.CurrencyUnit
                                        )
                                        : moneyFormat(
                                            (materialSum + labourSum + transportSum + ExtraSum)
                                            -
                                            (materialVatSum + labourVatSum + transportVatSum + ExtraVatSum), SessionUser.TenantCode, SessionUser.CurrencyUnit
                                        )
                                    :
                                    moneyFormat(
                                        (transportSum + ExtraSum)
                                        -
                                        (transportVatSum + ExtraVatSum), SessionUser.TenantCode, SessionUser.CurrencyUnit
                                    )
                                }
                            </Typography>
                        </Grid>
                        <Grid item xs={2} align="center">
                            <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                                {SessionUser.CurrencyUnit}
                            </Typography>
                        </Grid>

                        <Grid item xs={6} align="right">
                            <Typography className={classes.title} style={{ color: 'red' }} color="textSecondary" gutterBottom>
                                {t('Toplam')}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} align="right">
                            <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                                {priceVisible ?
                                    isPosTenantVat
                                        ? moneyFormat(
                                            Math.round(materialSum * 100) / 100
                                            + Math.round(labourSum * 100) / 100
                                            + Math.round(transportSum * 100) / 100
                                            + Math.round(ExtraSum * 100) / 100, SessionUser.TenantCode, SessionUser.CurrencyUnit
                                        )
                                        : moneyFormat(
                                            (materialSum + labourSum + transportSum + ExtraSum), SessionUser.TenantCode, SessionUser.CurrencyUnit
                                        )
                                    :
                                    moneyFormat(
                                        (transportSum + ExtraSum), SessionUser.TenantCode, SessionUser.CurrencyUnit
                                    )
                                }
                            </Typography>
                        </Grid>
                        <Grid item xs={2} align="center">
                            <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                                {SessionUser.CurrencyUnit}
                            </Typography>
                        </Grid>
                    </Grid>

                    <br />
                    <SelectDefect
                        open={openDefect}
                        onClose={() => setOpenDefect(false)}
                        title={t('hizmet_secimi')}
                    />
                    <SelectMaterial
                        open={openMaterial}
                        onClose={() => { setOpenMaterial(false); setMaterialFilterKey(''); setGosterimAdet(30); }}
                        title={t('malzeme_secimi')}
                        GosterimAdet={GosterimAdet}
                        setGosterimAdet={setGosterimAdet}
                        defect={props.defects.currentDefect}
                    />


                    <SelectLabour
                        open={openLabour}
                        onClose={() => { setOpenLabour(false); setLabourFilterKey(''); }}
                        garantiTipi={props.garantiTipi}
                        title={t('iscilik_secimi')}
                        defect={props.defects.currentDefect}
                    />

                    <br />
                    <Dialog
                        open={ExtraOpen}
                        fullWidth
                        maxWidth="xs"
                        onClose={() => setExtraOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {t('lblYanOdeme')}
                            <Divider />
                        </DialogTitle>
                        <DialogContent>
                            <Card>
                                <CardHeader title={t('lblTransport')} />
                                <Divider />
                                <CardContent>
                                    {loading ? (
                                        <CircularProgress status="loading" style={{ marginLeft: '50%' }} />) :
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={12} lg={12}>
                                                <br />
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={12}>
                                                <Slider
                                                    value={typeof Km === 'number' ? Km : 0}
                                                    onChange={handleSliderChange}
                                                    aria-labelledby="input-slider"
                                                    valueLabelDisplay="on"
                                                    min={0}
                                                    max={ExtraPaymentTypeData[0]?.MaxKm || 130}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} lg={12}>
                                                <TextField
                                                    id="outlined-number"
                                                    label={t('Km')}
                                                    size="small"
                                                    type="number"
                                                    // onBlur={handleBlur}
                                                    inputProps={{
                                                        step: 1,
                                                        min: 0,
                                                        max: ExtraPaymentTypeData[0]?.MaxKm,
                                                        type: 'number',
                                                        'aria-labelledby': 'input-slider',
                                                        style: { textAlign: 'right' }
                                                    }}
                                                    fullWidth
                                                    value={Km}
                                                    onChange={handleChangeKm}
                                                    variant="outlined"
                                                />
                                            </Grid>
                                            {
                                                SessionUser.ServiceShopPriceVisible ?
                                                    <>
                                                        <Grid item xs={12} sm={9} lg={9}>
                                                            <TextField
                                                                disabled
                                                                size="small"
                                                                id="outlined-disabled"
                                                                label={t('lblPrice')}
                                                                variant="outlined"
                                                                fullWidth
                                                                value={moneyFormat(
                                                                    TotalExtraPrice,
                                                                    SessionUser.TenantCode,
                                                                    SessionUser.CurrencyUnit
                                                                )}
                                                                inputProps={{
                                                                    style: { textAlign: 'right' }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={3} lg={3}>
                                                            <TextField
                                                                disabled
                                                                size="small"
                                                                id="outlined-disabled"
                                                                label={t('lblVat')}
                                                                variant="outlined"
                                                                fullWidth
                                                                value={'%' + ExtraPaymentTypeData[0]?.VatRate * 100}
                                                                inputProps={{
                                                                    style: { textAlign: 'right' }
                                                                }}
                                                            />
                                                        </Grid>
                                                    </> : null
                                            }

                                            <Grid item xs={12} sm={12} lg={12}>
                                                <Typography variant="h6" gutterBottom>
                                                    {t('lblExtraPaymentDetailDsc')}
                                                </Typography>
                                            </Grid>
                                        </Grid>}
                                </CardContent>
                            </Card>
                            <Card>
                                <CardHeader title={t('lblExtra')} />
                                <Divider />
                                <CardContent>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12} lg={12}>
                                            <TextField
                                                size="small"
                                                id="outlined-disabled"
                                                label={t('lblPrice')}
                                                variant="outlined"
                                                onChange={e => AddExtraPriceNew(e)}
                                                fullWidth
                                                value={TotalExtraNewPriceParam}
                                                inputProps={{
                                                    style: { textAlign: 'right' }
                                                }}
                                            />

                                        </Grid>
                                        <Grid item xs={12} sm={9} lg={9}>
                                            <TextField
                                                size="small"
                                                disabled
                                                id="outlined-disabled"
                                                label={t('lblPrice')}
                                                variant="outlined"
                                                onChange={e => AddExtraPriceNew(e)}
                                                fullWidth
                                                value={moneyFormat(
                                                    TotalExtraNewPrice,
                                                    SessionUser.TenantCode,
                                                    SessionUser.CurrencyUnit
                                                )}
                                                inputProps={{
                                                    style: { textAlign: 'right' }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3} lg={3}>
                                            <TextField
                                                disabled
                                                size="small"
                                                id="outlined-disabled"
                                                label={t('lblVat')}
                                                variant="outlined"
                                                fullWidth
                                                value={'%' + ((ExtraPaymentTypeData && ExtraPaymentTypeData[0]?.VatRate) ? ExtraPaymentTypeData[0]?.VatRate : 0) * 100}
                                                inputProps={{
                                                    style: { textAlign: 'right' }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} lg={12}>
                                            <TextField
                                                size="small"
                                                id="outlined-disabled"
                                                label={t('lblNote')}
                                                variant="outlined"
                                                onChange={e => SetExtraNote(e)}
                                                fullWidth
                                                value={extraFeeNote}
                                                inputProps={{
                                                    style: { textAlign: 'left' }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => setExtraPrice()}
                                endIcon={<SendIcon>Close</SendIcon>}
                            >
                                {t('lblEkle')}
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => deleteExtraPrice()}
                                endIcon={<DeleteIcon>Delete</DeleteIcon>}
                            >
                                {t('SilButon')}
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => setExtraOpen(false)}
                                endIcon={<CloseIcon>Close</CloseIcon>}
                            >
                                {t('lblClose')}
                            </Button>

                        </DialogActions>
                    </Dialog>

                    <Dialog

                        open={NonIotOpen}
                        onClose={() => setNonIotOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullScreen
                    >
                        <DialogTitle id="alert-dialog-title">
                            {t('Cihaz_Ariza_Bilgileri')}
                            <Divider />
                        </DialogTitle>
                        <DialogContent>
                            {
                                grafikGetir
                                    ? <img src="/images/wudaq.gif" alt="nice" />
                                    : (
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <div
                                                    style={{
                                                        height: '400px'
                                                    }}
                                                >
                                                    <Chart data={data} series={series} axes={axes} />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    )
                            }

                        </DialogContent>
                        <DialogActions>
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => setNonIotChartOpen()}
                                        className={classes.submitButtonWudaq}
                                        endIcon={<SettingsRemoteIcon>Getir</SettingsRemoteIcon>}
                                    >
                                        {t('Bilgileri_getir')}
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => setNonIotOpen(false)}
                                        className={classes.submitButtonWudaq}
                                        endIcon={<CloseIcon>Close</CloseIcon>}
                                    >
                                        {t('Kapat')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={stokOpen}
                        onClose={() => setStokOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth
                    >
                        <DialogTitle id="alert-dialog-title">
                            {t('Malzeme_Stok_Durumu')}
                            <Divider />
                        </DialogTitle>
                        <DialogContent>
                            <List component="div" dense>
                                {loading ? (
                                    <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
                                ) : (
                                    <>
                                        {/* stokDataOwnEngineer */}
                                        {serviceShopTypeId === 1 ? (
                                            <>
                                                {stokDataOwnEngineer.length > 0 ? (
                                                    <>
                                                        <Typography>{t('VanStock')}</Typography>
                                                        {stokDataOwnEngineer.map((s, index) => (
                                                            <React.Fragment key={index}>
                                                                <ListItem fullWidth alignItems="flex-start">
                                                                    <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                                                                    <ListItemText
                                                                        primary={
                                                                            <Typography variant="body1" className={classes.nestedRight}>
                                                                                <b>{s.MaterialCode}</b>
                                                                            </Typography>
                                                                        }
                                                                        secondary={
                                                                            <>
                                                                                <Typography
                                                                                    component="span"
                                                                                    variant="h6"
                                                                                    className={classes.inline}
                                                                                    color="textPrimary"
                                                                                >
                                                                                    {t('OwnEngineer')} : {s.StorageLocation}
                                                                                    <br />
                                                                                    {t('lblAdet')} : {s.Quantity}
                                                                                    <br />
                                                                                    {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : '-'}
                                                                                    <br />
                                                                                    {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 ? (
                                                                                        <div>
                                                                                            {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity === 0 ? '-' : moment(s.ETA).format('DD/MM/YYYY')}
                                                                                        </div>
                                                                                    ) : null}
                                                                                </Typography>
                                                                            </>
                                                                        }
                                                                    />
                                                                </ListItem>
                                                                <Divider variant="inset" component="li" />
                                                            </React.Fragment>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <Typography>{stockMsg}</Typography>
                                                )}
                                            </>
                                        ) : null}
                                        <Divider variant="inset" component="li" />
                                        {/* stokData */}
                                        {stokData.length > 0 && IsAllOwnEngineer == false ? <Typography>Stock Data</Typography> : ''}
                                        {stokData.length > 0 && IsAllOwnEngineer == false ? stokData.map((s, index) => (
                                            <React.Fragment key={index}>
                                                <ListItem fullWidth alignItems="flex-start">
                                                    <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                                                    <ListItemText
                                                        primary={
                                                            <Typography
                                                                variant="body1"
                                                                className={classes.nestedRight}
                                                            >
                                                                <b>{s.MaterialCode}</b>
                                                            </Typography>
                                                        }
                                                        secondary={
                                                            <React.Fragment>
                                                                <Typography
                                                                    component="span"
                                                                    variant="h6"
                                                                    className={classes.inline}
                                                                    color="textPrimary"
                                                                >
                                                                    {t('StorageDesc')} : {s.StorageLocation}
                                                                    <br />
                                                                    {t('lblAdet')} : {s.Quantity}
                                                                    <br />
                                                                    {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : "-"}
                                                                    <br />
                                                                    {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 && (
                                                                        <div>
                                                                            {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity == 0 ? "-" : moment(s.ETA).format('DD/MM/YYYY')}
                                                                        </div>
                                                                    )}
                                                                </Typography>
                                                            </React.Fragment>
                                                        }
                                                    />
                                                </ListItem>
                                                <Divider variant="inset" component="li" />
                                            </React.Fragment>
                                        )) : ''}
                                    </>
                                )}
                            </List>
                        </DialogContent>
                        <DialogActions>
                            {serviceShopTypeId == 1 ? <div>
                                {backButtonVisible ? (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleBackButtonClick}
                                    >
                                        {t('lblBack')}
                                    </Button>
                                ) :
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => StockSearch(false)}
                                    >
                                        {t('lblFieldStock')}
                                    </Button>
                                }
                            </div> : ''}
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setStokOpen(false)}
                            >
                                {t('Tamam')}
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Dialog
                        open={VatOpen}
                        fullWidth
                        maxWidth="xs"
                        onClose={() => setVatOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{t('VatType')}</DialogTitle>
                        <Divider />
                        <DialogContent>
                            <FormControl fullWidth>
                                <InputLabel id="vat-select-label">{t('VatType')}</InputLabel>
                                <Select
                                    labelId="vat-select-label"
                                    value={vatType}
                                    onChange={handleVatChange}
                                    size="small"
                                >
                                    {vatRates.map((rate) => (
                                        <MenuItem key={rate.Id} value={rate.Id}>
                                            {rate.Code}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </DialogContent>
                    </Dialog>


                </Card>
            ) : (
                <Card>
                    <CardContent>
                        <ErrorMessage message={t('Offline_Message')} />
                    </CardContent>
                </Card>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    defects: state.defectReducer,
    materials: state.materialReducer,
    labours: state.labourReducer,
    tasks: state.tasks1,
});

const mapDispatchToProps = {
    setCurrentDefect,
    setDefectFilterKey,
    setLabourFilterKey,
    setMaterialFilterKey,
    setMaterialSelection,
    setLabourSelection,
    getHistoricalMaterialRequest,
    setTask
};
mapStateToProps.propTypes = {
    className: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefectPage);
